import invoiceLabels from "emun.invoice/_labels";
import creditRequestConfig from "emun.invoice/credit-request/credit-request.config";
import emailInvoicePrompt from "emun.invoice/email-invoice-prompt";
import invFilters from "emun.invoice/inv/inv-container.filters";
import sortOptions from "emun.invoice/inv/inv-container.sort-options";
import views from "emun.invoice/inv/inv-container.views";
import Invoice from "emun.invoice/inv/inv.model";
import PrintInvoiceOptions from "emun.invoice/invoice-print";
import invoiceConfig from "emun.invoice/invoice.config";
import invoicePicker from "emun.invoice/picker/invoice-picker";
import orderLabels from "emun.order/_labels";
import dateRanges from "emun.order/order-container.date-ranges";
import orderConfig from "emun.order/order.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import formSubmissionPrompt from "webforms/formio/formio-submission-prompt";
import actionList from "webmodals/action-list";

export default class InvoiceContainerController extends BasicAutoQueryController {
  constructor() {
    super();
    const $ctrl = this;
    $ctrl.ngModel = this;
    $ctrl.labels = Object.assign({}, orderLabels, invoiceLabels);
    $ctrl.config = Object.assign({}, orderConfig, invoiceConfig);
    $ctrl.orderConfig = orderConfig;
    $ctrl.invoiceConfig = invoiceConfig;
    $ctrl.creditRequestConfig = creditRequestConfig;
    $ctrl.dateRanges = dateRanges;
    $ctrl.dateRange = dateRanges[0].id;
    var transactionType = `TransactionType${
      $ctrl.mode === "creditmemo" ? "" : "NotEqualTo"
    }`;

    //BL removed this 6/16/23 it was being reported as a bug showing all transaction types when going into credit memos
    if ($ctrl.$session.isRetailer() && $ctrl.config.showAllInvoiceTransactionTypes) {
      transactionType = `TransactionTypeAllOfThem`;
    }
    
    $ctrl.invoiceTotalQuery = new AutoQuery({
      url: `QueryInvoicesJoin.json?Sum=TotalOrder,InvoiceTotal&GroupBy=Status&Count=Status`,
      orderBy: null,
      criteria: {
        retailerId: $ctrl.resolveCustomerId(),
        productId: $ctrl.productId,
        [transactionType]: "CreditMemo",
      },
      disableQueryString: true,
      autoLoad: false,
      onLoaded: (args) => $ctrl.onInvoiceTotalsLoaded(args),
    });
    if (!invoiceConfig.hideLeftNavFilters) {
      $ctrl.query.toggleLeftNav();
    }
    $ctrl.$on("$stateChangeSuccess", (event, toState, { invoiceId } = {}) => {
      console.debug(this, event, toState, invoiceId);
      if (invoiceId) {
        $ctrl.invoiceId = invoiceId;
        $ctrl.query.invoiceId = invoiceId;
      }
    });
  }

  resolveCustomerId() {
    const $ctrl = this;
    return (
      $ctrl.retailerId ||
      $ctrl.customerId ||
      ($ctrl.customer ? $ctrl.customer.id : undefined)
    );
  }

  onInvoicesLoaded(args) {
    const $ctrl = this;
    $ctrl.invoiceTotalQuery.criteria = { ...$ctrl.query.criteria };
    $ctrl.invoiceTotalQuery.load(true);
  }

  onInvoiceTotalsLoaded(args) {
    const $ctrl = this;
    $ctrl.totalSales = 0;
    $ctrl.totalOrder = 0;
    args.results.forEach(function (obj) {
      $ctrl.totalSales += obj.sumInvoiceTotal;
      $ctrl.totalOrder += obj.sumTotalOrder;
    });
  }

  getQuery() {
    const $ctrl = this;
    var filters = [];
    const retailerId = $ctrl.resolveCustomerId();
    if (retailerId) {
      //url = url + `?retailerId=${encodeURIComponent(retailerId)}`;
      filters.push({
        groupBy: "ShippingLocationAddress",
        title: "Ship Address",
      });
    }
    invFilters.forEach(function (obj) {
      filters.push(obj);
    });
    var transactionType = `TransactionType${
      $ctrl.mode === "creditmemo" ? "" : "NotEqualTo"
    }`;

    //BL removed this 6/16/23 it was being reported as a bug showing all transaction types when going into credit memos
    if ($ctrl.$session.isRetailer() && invoiceConfig.showAllInvoiceTransactionTypes) {
      transactionType = `TransactionTypeAllOfThem`;
    }
    return {
      url: `QueryInvoicesJoin.json?op=InvContainer`,
      fields:
        invoiceConfig.invoiceFields ||
        "Id,InvoiceDate,RetailerId,ShipId,DueDate,Status,InvoiceTotal,CreditMemoTotal,TotalFreight,SalesRepId,PaymentTermsId,CompanyName,TransactionType,PONumber,OrderNumber,Division,TagFor,Reason,Description,RetailerEmail,SalesRepName,InvoiceBalance",
      orderBy: invoiceConfig.invoiceOrderBy,
      disableQueryString: !!$ctrl.disableQueryString,
      pageSize: 12,
      criteria: {
        retailerId,
        orderNumber: $ctrl.orderId ? $ctrl.orderId : undefined,
        productId: $ctrl.productId,
        [transactionType]: "CreditMemo",
      },
      views,
      view: $ctrl.$pageConfig.is("gt-md") ? "list" : "cards",
      filters,
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      autoLoad: true,
      sortOptions,
      scrub(res) {
        res.data.results = res.data.results.map((inv) => new Invoice(inv));
      },
      onLoaded: (args) => $ctrl.onInvoicesLoaded(args),
    };
  }
  selectDateRange() {
    const $ctrl = this;
    $ctrl.query.criteria.DateRange = $ctrl.dateRange;
    $ctrl.query.load(true);
  }
  bulkActions(model) {
    const $ctrl = this;
    return invoicePicker({
      title: "Select Invoices...",
      view: "table",
      backdrop: false,
      placement: "center",
      criteria: $ctrl.query.criteria,
    }).finally(() => $ctrl.query.load(true));
  }
  printInvoice(invoice) {
    const $ctrl = this;
    return PrintInvoiceOptions({
      request: {
        id: invoice,
        IncludeImages: false,
        IncludeBarcodes: false,
        OrderBy: "strProductID",
      },
    });
  }
  emailInvoice(invoice) {
    //emailInvoicePrompt(options);
    const $ctrl = this;
    return emailInvoicePrompt({
      id: invoice,
      invoiceNumber: invoice,
      from: $ctrl.$session.email,
      to: invoice.retailerEmail,
      subject: $ctrl.$session.clientName + " Invoice #" + invoice.id,
      clientName: $ctrl.$session.clientName,
      status: invoice.status,
      IncludeImages: false,
      IncludeBarcodes: false,
      OrderBy: "strProductID",
    });
  }

  exportToExcel(withImages) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=InvoiceExport&displayName=InvoiceExport&includeImages=" +
        withImages +
        "&output=xlsx&invoiceNumber=" +
        $ctrl.invoice.id
    );
    return (location.href = url);
  }

  onCreditMemoCreated(invoice, creditMemo) {
    const $ctrl = this;
    return $ctrl.$state.transitionTo("retailer.creditmemo", {
      invoiceId: invoice.id,
      retailerId: invoice.retailerId,
      id: creditMemo.id,
    });
  }

  canRequestReturn(invoice) {
    const $ctrl = this;
    return (
      !$ctrl.$session.isSalesManagementMode() && $ctrl.mode !== "creditmemo"
    );
  }

  return(invoice) {
    const $ctrl = this;
    if (
      $ctrl.creditRequestConfig.invoiceAgeLimit && $ctrl.creditRequestConfig.invoiceAgeLimit > -1 && 
      moment(invoice.invoiceDate).isBefore(
        moment().subtract($ctrl.creditRequestConfig.invoiceAgeLimit, "day")
      )
    ) {
      const returnActions = {
        "Contact Customer Service": {
          icon: "envelope",
          body: "Contact Customer Service",
          handler: () => {
            formSubmissionPrompt(
              Object.assign({
                title: "Contact Us by Email",
                formioId: $ctrl.creditRequestConfig.invoiceAgeLimitFormIo || "Contact Us",
              })
            );
          },
        },
        Cancel: {
          icon: "close",
          body: "Cancel claim request",
          handler: () => false,
        },
      };
      return actionList({
        title: `Claim Request`,
        body: `This invoice is more than ${$ctrl.creditRequestConfig.invoiceAgeLimit} days old.  To submit a claim please contact customer service for review`,
        actions: returnActions,
        size: "md",
      }).then((a) => a.handler());
    } else {
      $ctrl.$state.transitionTo("inv.request-credit", {
        retailerId: invoice.retailerId,
        orderId: invoice.orderNumber,
        invoiceId: invoice.invoiceNumber,
      });
    }
  }
  requestReturn(invoice) {
    const $ctrl = this;
    const creditMemo = {
      invoiceId: invoice.id,
      retailerId: invoice.retailerId,
      status: $ctrl.creditRequestConfig.creditRequestDefaultStatus || "Open",
    };

    $ctrl.bus
      .send("CreateCreditMemoRequest.json?jsconfig=ua,uaa", creditMemo)
      .then(
        (res) => $ctrl.onCreditMemoCreated(invoice, res.data),
        (res) => {
          if (res.data.responseStatus.errorCode == "CreditMemoRequestExists") {
            modals
              .confirm(
                "A credit request already exists for this invoice.  Would you like to open it?"
              )
              .result.then(function () {
                return $ctrl.$state.transitionTo("retailer.credit-request.detail", {
                  retailerId: invoice.retailerId,
                  creditRequestId: res.data.responseStatus.errors[0].fieldName,
                });
              });
          }
        }
      );
  }

  canMakePayment(invoice) {
    const $ctrl = this;
    return (
      !$ctrl.$session.isSalesManagementMode() && $ctrl.mode !== "creditmemo"
    );
  }

  makePayment(invoice) {
    const $ctrl = this;
    $ctrl.$state.transitionTo("retailer.payments", {
      retailerId: invoice.retailerId || $ctrl.resolveCustomerId(),
      orderId: invoice.orderNumber,
      invoiceId: invoice.invoiceNumber,
    });
  }

  statusCss(status) {
    switch ((status || "").replace(/\W/gi, "").toLowerCase()) {
      case "invoice":
        return "label-warning";
      case "inprogress":
      case "open":
        return "label-success";
      case "complete":
        return "bg-color-1";
      case "cancel":
      case "cancelled":
      case "deleted":
        return "label-danger";
      case "shipped":
        return "bg-color-4";
    }
    return "label-default";
  }
}
